import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog'
import { cn } from '../ui/utils'

interface ConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  onConfirm: () => void
  confirmText?: string
  variant?: 'default' | 'destructive'
  className?: string
}

export function ConfirmationDialog({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  confirmText = 'Confirm',
  variant = 'default',
  className,
}: ConfirmationDialogProps) {
  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        className={cn('rounded-[var(--r-xl)] border shadow-[var(--shadow-lg)]', className)}
        style={{
          background: 'var(--bg-modal)',
          borderColor: 'var(--border-md)',
          color: 'var(--text-primary)',
        }}
      >
        <AlertDialogHeader>
          <AlertDialogTitle style={{ color: 'var(--text-primary)' }}>{title}</AlertDialogTitle>
          <AlertDialogDescription style={{ color: 'var(--text-muted)' }}>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="hover:opacity-95"
            style={{
              background: 'var(--bg-card)',
              borderColor: 'var(--border-md)',
              color: 'var(--text-secondary)',
            }}
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className={cn(
              variant === 'destructive'
                ? 'text-white hover:opacity-95'
                : 'text-white hover:opacity-95',
            )}
            style={{
              background: variant === 'destructive' ? '#ef4444' : 'var(--accent)',
              borderColor: variant === 'destructive' ? '#ef4444' : 'var(--accent)',
            }}
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
